<template>
  <div class="card shadow p-3">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">
            {{ title }}
          </h3>
        </div>
        <div class="col text-right">
          <b-button
          size="sm"
          v-b-modal.modal-excel
          variant="outline-primary"
          >{{ $t("excel-button") }}</b-button
          >
          <b-button
          size="sm"
          @click="update()"
          class="mr-sm-2"
          variant="outline-primary"
          >{{ $t("add") }}</b-button
          >
        </div>
      </div>
    </div>

    <!-- <div class="table-responsive"> -->
      <b-row>
        <b-col md="2">
          <b-form-select
          v-model="perPage"
          :options="[5, 10, 20, 100]"
          @input="changePerPage"
          size="sm"
          class="mt-2"
          ></b-form-select>
        </b-col>
        <b-col class="ml-auto col-sm-12 col-md-6 col-lg-6 mb-3">
          <b-form-group>
            <b-input-group>
              <b-form-input
              class="form-control-sm"
              type="search"
              v-model="searchData"
              :placeholder="$t('search')"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="12" class="table-responsive">
          <b-table
          class="align-items-center table-flush tablesorter table-text"
          hover
          :items="tableData.data ? tableData.data : []"
          :fields="columns"
          :per-page="perPage"
          :current-page="currentPage"
          >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <span class="h2 text-danger">{{ $t("fail") }}</span>
            </div>
          </template>
          <template v-slot:cell(price)="data">
            {{ data.item.currency ? data.item.currency.symbol : '' }} {{ data.item.price }}
          </template>
          <template v-slot:cell(total_quantity)="data">
            {{data.item.total_quantity ? data.item.total_quantity : '0' }}           
          </template>
          <template v-slot:cell(actions)="data">
            <b-button
            v-b-tooltip.hover
            :title="$t('show_inventory')"
            v-if="data.item.status === 'INVENTORIED'"
            :variant="data.item.total_quantity >= 5 ? 'success' : 'danger'"
            size="sm"
            @click="
            $router.push({
              name: 'inventory_show',
              params: { id: data.item.id },
            })
            "
            ><i class="fas fa-boxes">
              </i
              ></b-button>
              <b-button
              v-b-tooltip.hover
              :title="$t('create_inventory')"
              v-else
              variant="dark"
              size="sm"
              @click="
              $router.push({
                name: 'create_inventory',
                params: { id: data.item.id, type: 1, company: form.company_id },
              })
              "
              ><i class="far fa-plus-square"></i
              ></b-button>
              <b-button
              v-b-tooltip.hover
              :title="$t('show')"
              variant="info"
              size="sm"
              v-b-modal.modal-1
              @click="
              $router.push({
                name: 'products_show',
                params: { id: data.item.id },
              })
              "
              ><i class="far fa-eye"></i
              ></b-button>
              <b-button
              v-b-tooltip.hover
              :title="$t('edit')"
              variant="warning"
              size="sm"
              @click="update(data.item.id)"
              ><i class="far fa-edit"></i
              ></b-button>
              <b-button
              v-b-tooltip.hover
              :title="$t('delete')"
              variant="danger"
              size="sm"
              @click="deleteProduct(data.item.id)"
              ><i class="far fa-trash-alt"></i
              ></b-button>
            </template>
          </b-table>
          <b-pagination
          class="mt-3"
          v-model="tableData.current_page"
          :total-rows="tableData.total"
          :per-page="tableData.per_page"
          :page-count="tableData.per_page"
          @input="changePage"
          first-number
          pills
          size="sm"
          align="center"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal id="modal-excel" :title="$t('excel-button')" hide-footer>
        <div class="">
          <p>
            {{ $t("instructions-xlsx") }}
          </p>
          <form @submit.prevent="onSubmit">
            <b-form-file
            browse-text=".xlsx"
            accept=".XLSX"
            class="p-2"
            v-model="form.file"
            :placeholder="$t('excel-button')"
            ></b-form-file>
            <b-link
            :href="downloadFile"
            target="_blank"
            class="btn btn-success btn-sm mt-1"
            >{{ $t("example-xlsx") }}</b-link
            >
            <hr />
            <b-button
            class="ml-1 float-right"
            variant="primary"
            @click="goUpMassively()"
            >{{ $t("save") }}</b-button
            >
            <b-button
            class="float-right iq-bg-danger"
            variant="none"
            @click="$bvModal.hide('modal-excel')"
            >{{ $t("cancel") }}</b-button
            >
          </form>
        </div>
      </b-modal>
      <b-modal size="lg" id="modal-1" title="Detalles de producto">
        <div class="pl-lg-4">
          <div class="row">
            <div class="mb-3 row col-12">
              <div class="col-lg-4 mb-4">
                <span class="h3">{{ $t("sku") }}</span
                ><br />
                <span>{{ showData.sku }}</span>
              </div>
              <div class="col-lg-4 mb-4">
                <span class="h3">{{ $t("name") }}</span
                ><br />
                <span>{{ showData.name }}</span>
              </div>
              <div class="col-lg-12 mb-12">
                <span class="h3">{{ $t("description") }}</span
                ><br />
                <p>{{ showData.description }}</p>
              </div>
              <div class="col-lg-12">
                <span class="h3">{{ $t("category") }}</span
                ><br />
                <span v-for="(item, index) in showData.categories" :key="index">{{
                  item.name
                }}</span>
              </div>
            </div>
          </div>
          <hr class="my-4" />
        </div>
      </b-modal>
      <b-modal
      id="modal-product"
      size="lg"
      no-close-on-backdrop
      :title="$t('products')"
      hide-footer
      >
      <createOrUpdate :data="dataProduct" @close="hideProduct" />
    </b-modal>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from "vuex";
  import createOrUpdate from "@/views/BackOffice/Products/form/createOrUpdate.vue";
  import Swal from "sweetalert2/dist/sweetalert2.js";
  import "sweetalert2/src/sweetalert2.scss";
  import _ from "lodash";
  export default {
    name: "products-table",
    components: {
      createOrUpdate,
    },
    props: {
      type: {
        type: String,
      },
      title: String,
    },
    async mounted() {
      if (!this.modal) {
        await this.getProducts({
          currentPage: this.currentPage,
          perPage: this.perPage,
          company_id: this.$route.params.id,
        });
      }
      this.debouncedGetAnswer = _.debounce(this.search, 500);
    },
    watch: {
      searchData: function (newQuestion, oldQuestion) {
        this.debouncedGetAnswer();
      },
    },
    data() {
      return {
        modalActive: false,
        showData: "",
        perPage: 5,
        currentPage: 1,
        form: {
          file: null,
          company_id: this.$route.params.id,
        },
        file: require("@/assets/doc/example.xlsx"),
        searchData: "",
        dataProduct: null,
      };
    },
    methods: {
      ...mapActions({
        getProducts: "product/get",
        delProduct: "product/delete",
        saveExcel: "product/saveExcel",
        showProduct: "product/getProduct",
      }),
      async search(data) {
        await this.getProducts({
          currentPage: this.currentPage,
          perPage: this.perPage,
          search: this.searchData,
          company_id: this.$route.params.id,
        });
      },
      async changePage(value) {
        await this.getProducts({
          currentPage: value ? value : 1,
          perPage: this.perPage,
          company_id: this.$route.params.id,
        });
      },
      async changePerPage() {
        await this.getProducts({
          currentPage: this.currentPage,
          perPage: this.perPage,
          company_id: this.$route.params.id,
        });
      },
      async deleteProduct(id) {
        await Swal.fire({
          title: this.$t("are_you_sure?"),
          text: this.$t("question_delete_item"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#172b4d",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("not"),
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              const res = await this.delProduct(id);
              this.$toast.success(res.message, {
                position: "top-right",
              });
              await this.changePerPage();
            } catch (error) {
              console.log(error);
            }
          }
        });
      },
      async goUpMassively() {
        const res = await this.saveExcel(this.form);
        this.$toast.success(res.message, {
          position: "top-right",
        });
        this.$bvModal.hide("modal-excel");
      },
      async update(id) {
        if (!id) {
          this.dataProduct = null;
          this.$bvModal.show("modal-product");
        } else {
          const res = await this.showProduct(id);
          this.dataProduct = res.data;
          this.$bvModal.show("modal-product");
        }
      },
      async hideProduct(change) {
        this.$bvModal.hide("modal-product");
        if (change) await this.changePerPage();
      },
    },
    computed: {
      ...mapGetters({
        tableData: "product/products",
      }),
      columns() {
        return [
        { label: this.$t("name"), key: "name", class: "text-center" },
        { label: this.$t("sku"), key: "sku", class: "text-center" },
        { label: this.$t("sku"), key: "sku", class: "text-center" },
        { label: this.$t("total_quantity"), key: "total_quantity", class: "text-center" },
        { label: this.$t("actions"), key: "actions", class: "text-center" },
        ];
      },
      downloadFile() {
        const locale = this.$i18n.locale;
        if (locale === "en") return require("@/assets/doc/example.xlsx");
        else if (locale === "es") return require("@/assets/doc/ejemplo.xlsx");
        else if (locale === "de") return require("@/assets/doc/beispiel.xlsx");
      }
    }
  };
</script>